module.exports = __webpack_public_path__ + "src/img/pcWatch.5a6c8013.png";